import { Suspense } from "react";
import MatxLoading from "./MatxLoading";

const MatxSuspense = ({ children }) => {
  return <Suspense fallback={<MatxLoading />}>{children}</Suspense>;
};

export default MatxSuspense;
